import React from 'react';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';

const Step3Pruebas = ({ formData, updateFormData }) => {
  return (
    <div className="space-y-6">
      <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
        <h3 className="text-lg font-semibold text-[#505BB3] mb-4">Pruebas Solicitadas *</h3>
        <div className="space-y-2">
          <Label htmlFor="pruebaSolicitada">
            Describa las pruebas de laboratorio que solicita *
          </Label>
          <Textarea
            id="pruebaSolicitada"
            placeholder="Especifique las pruebas que necesita realizar..."
            value={formData.pruebaSolicitada}
            onChange={(e) => updateFormData('pruebaSolicitada', e.target.value)}
            rows={6}
            required
            className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3] resize-none"
          />
        </div>
      </div>

      <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
        <h3 className="text-lg font-semibold text-[#505BB3] mb-4">Observaciones</h3>
        <div className="space-y-2">
          <Label htmlFor="observaciones" className="text-sm text-gray-600">
            Diagnóstico presuntivo, historia clínica / Tratamiento antes de la toma de muestra, etc.
          </Label>
          <Textarea
            id="observaciones"
            placeholder="Incluya cualquier información adicional relevante..."
            value={formData.observaciones}
            onChange={(e) => updateFormData('observaciones', e.target.value)}
            rows={6}
            className="border-gray-300 focus:border-[#505BB3] focus:ring-[#505BB3] resize-none"
          />
        </div>
      </div>
    </div>
  );
};

export default Step3Pruebas;